"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ls = require("local-storage");
const mechanism = "storagesync";
exports.storagesync = (context) => {
    const createStorageController = (publisher, subscriber) => {
        let isRunning = false;
        let last = {};
        const trigger = (...args) => {
            context.logger.debug(`trigger(${args.join(", ")})`);
            const value = publisher(...args);
            ls(context.options.channel, value);
        };
        const notifySubscriber = (value) => {
            subscriber(value, last, "");
            last = value;
        };
        const start = (sync = false) => {
            context.logger.debug(`start(sync = ${sync})`);
            ls.on(context.options.channel, notifySubscriber);
            if (sync) {
                const value = ls.get(context.options.channel);
                notifySubscriber(value);
            }
            isRunning = true;
        };
        const stop = () => {
            context.logger.debug("stop()");
            ls.off(context.options.channel, notifySubscriber);
            isRunning = false;
        };
        return {
            start,
            stop,
            trigger,
            get isRunning() {
                return isRunning;
            },
            mechanism,
            isFallback: false,
            isServer: false,
            instanceID: "storage"
        };
    };
    return createStorageController;
};
//# sourceMappingURL=storagesync.js.map